import { auth, db } from "../../firebaseConfig"; // Make sure to import your Firebase configuration
import { doc, setDoc } from "firebase/firestore";

const arrayToIndexedObject = (rows = []) => {
  return rows.reduce((acc, row, index) => {
    acc[index] = row;
    return acc;
  }, {});
};

const writeDataS3 = async (formData) => {
  // console.log("Form data for Section 3: ", formData);
  const user = auth.currentUser;
  try {
    const docRef1 = doc(
      db,
      "Advisers",
      user.uid,
      "Application Details",

      "Life Assurance Companies",
    );
    const docRef2 = doc(
      db,
      "Advisers",
      user.uid,
      "Application Details",

      "Work History",
    );
    const lifeAssuranceCompanies = arrayToIndexedObject(
      Array.isArray(formData?.lifeAssuranceCompanies)
        ? formData.lifeAssuranceCompanies
        : [],
    );
    const workHistory = arrayToIndexedObject(
      Array.isArray(formData?.workHistory) ? formData.workHistory : [],
    );

    await Promise.all([
      // Overwrite documents so removed rows are actually deleted in Firestore.
      setDoc(docRef1, lifeAssuranceCompanies),
      setDoc(docRef2, workHistory),
    ]);

    // console.log("Section 3 data successfully written to Firestore!");
  } catch (error) {
    // console.error("Error writing Section 3 data to Firestore: ", error);
  }
};

export default writeDataS3;
